/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_UserAccount_QueryVariables = {};
export type App_UserAccount_QueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"UserAccount_viewer">;
    } | null;
};
export type App_UserAccount_Query = {
    readonly response: App_UserAccount_QueryResponse;
    readonly variables: App_UserAccount_QueryVariables;
};



/*
query App_UserAccount_Query {
  viewer {
    ...UserAccount_viewer
    id
  }
}

fragment UserAccount_viewer on User {
  id
  firstName
  lastName
  email
  profileURL
}
*/

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "App_UserAccount_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserAccount_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "App_UserAccount_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileURL",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7909c738b441a601b864178450b36b6f",
    "id": null,
    "metadata": {},
    "name": "App_UserAccount_Query",
    "operationKind": "query",
    "text": "query App_UserAccount_Query {\n  viewer {\n    ...UserAccount_viewer\n    id\n  }\n}\n\nfragment UserAccount_viewer on User {\n  id\n  firstName\n  lastName\n  email\n  profileURL\n}\n"
  }
};
(node as any).hash = '356a45cf16a35514a19ab078ecfe2299';
export default node;
